import {Box, Divider, List, Stack, Typography} from "@mui/material";
import {Children, isValidElement, ReactNode, UIEvent, useEffect, useState} from "react";
import Preloader from "./Preloader";
import {SearchBox} from "./SearchBox";
import FilterSelector from "./FilterSelector";
import Card from "./Card";
import {FilterObject} from "./FilterTable";

// editCols must be a link to the collection where to alter docs

type Params = {
    title?: string|ReactNode,
    data?: {[key:string]: {[key:string]: unknown}},
    children?: ReactNode,
    sx?: {[key:string]: unknown},
    actionButton?: ReactNode,
    onScrollBottom?: () => void,
    loadMoreIcon?: boolean|"loaded",
    onSearch?: (query:string) => void,
    noResultsText?: ReactNode,
    card?: boolean,
    hideNoResultsText?: boolean,
    filters?: FilterObject
    urlRef?: string,
    grid?: boolean,
    xs?: number,
    sm?: number,
    md?: number,
    lg?: number,
    endOfResults?: boolean,
    noSearch?: boolean
}

// editCols must be a link to the collection where to alter docs


export default function FilterList({title, data, children, sx, noSearch, actionButton, onScrollBottom, loadMoreIcon, onSearch, card=true, hideNoResultsText, filters, urlRef, grid, xs, sm, md, lg}:Params) {
    const [tableData, setTableData] = useState<string[]>([]);
    const [bottom, setBottom] = useState(false);

    const handleScroll = (e:UIEvent<HTMLElement>) => {
        const scrolledToBottom = Math.floor((e.currentTarget.scrollHeight - e.currentTarget.scrollTop)/10) === Math.floor(e.currentTarget.clientHeight/10);

        if (scrolledToBottom && !bottom) {
            setBottom(true);
            loadMoreIcon === false && onScrollBottom && onScrollBottom();
        } else if (!scrolledToBottom) {
            setBottom(false);
        }
    };

    useEffect(() => {
        if (!data) return;
        setTableData(Object.keys(data));
    }, [data]);

    const search = (query:string) => {
        if (onSearch) {
            onSearch(query);
            return;
        }
        if (!data) return;
        setTableData(() => Object.keys(data).filter((key) => JSON.stringify(data[key]).includes(query)));
    };


    const returnItem = <>
        <List style = {{marginBottom: "50px"}}>
            {Children.map(children, (child) => {
                if (!isValidElement(child)) {
                    return child;
                }

                if (!tableData.includes(child.props?.id)) {
                    return null;
                }
                return child;
            }) as any}
            {loadMoreIcon === true ? <Preloader visible/> : loadMoreIcon === "loaded" ? (hideNoResultsText ? undefined : <Divider sx={{marginTop: "10px"}}>End of results</Divider>) : <Divider onClick={() => onScrollBottom && onScrollBottom()} sx={{textDecoration: "underline", cursor: "pointer", color: "#38383b", marginTop: "10px"}}>Load more</Divider>}
        </List>
    </>;

    const header = [
        <Typography variant="h5">{title as any}</Typography>,
        <Stack key={"search"} direction={"row"} alignItems={"center"} spacing={1}>
            {filters && <FilterSelector filters={filters} urlRef={urlRef}/>}
            {noSearch || <SearchBox placeholder={"Search"} onSearch={search}/>}
            {actionButton as any}
        </Stack>];

    if (card) {
        return (
            <Card sx={{...sx, height: "100%"}} {...{grid, xs, sm, md, lg}} title={header}>
                <div onScroll={handleScroll} style={{height: "100%", overflow: "auto"}}>
                    {returnItem}
                </div>
            </Card>
        );
    }
    return (
        <Box sx={{...sx, height: "100%"}}>
            <Stack direction={"row"} justifyContent={"space-between"}>{header}</Stack>
            <div style={{height: "100%", overflow: "auto"}} onScroll={handleScroll}>
                {returnItem}
            </div>
        </Box>
    );
}
